/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as UpCurvedArrow } from '../../assets/themes/OPL/img/icons/UpCurvedArrow.svg';

function ActivateFeatureButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={UpCurvedArrow}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

ActivateFeatureButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default ActivateFeatureButton;
